import { Input, Label } from "reactstrap";
import React from "react";
import moment from "moment";
import { map, some } from "lodash";

import CRMComponent from "./NewGestionCRMComponent";

const purchaseTerm = [
  { id: 'pt-1', value: 'before 30', label: 'Antes de 30 días' },
  { id: 'pt-2', value: 'after 30', label: 'Más de 30 días' },
];

const noTracking = ['No existe', 'No contesta', 'Correo enviado a cliente', 'Whatsapp enviado a cliente'];

const NewGestionForm = ({
  newManagementHandler,
  labelsHandler,
  valuesHandler,
  dateHandler,
  managementCreated,
  reminder,
  tracking,
  whenBuy,
  isEmail,
  emails,
  phones,
}) => {
  const { newManagement, setData } = newManagementHandler;
  const { labels, setLabels } = labelsHandler
  const { date, setDate } = dateHandler
  const trackingDisabled = tracking.loading || !tracking.entry || managementCreated.loading;
  const disableTracking = some(noTracking, (e) => labels.contactType === e);

  return (
    <div>
      <div className="crm-modal-form-group">
        <div className="crm-modal-input-group">
          <Label>{isEmail ? '*Correo' : '*Teléfono'}</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={isEmail ? newManagement.email : newManagement.phone}
            onChange={(e) => {
              setData({ ...newManagement, [isEmail ? 'email' : 'phone']: e.target.value });
            }}
            disabled={!newManagement.managementType || managementCreated.loading}
            required
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {!isEmail && map(phones, (e, index) => (
              <option key={`${e.number}-${index}`} value={e.number}>
                {e.number}
              </option>
            ))}
            {isEmail && map(emails, (e, index) => (
              <option key={`${e.email}-${index}`} value={e.email}>
                {e.email}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label>Estado de Seguimiento</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={newManagement.trakingStatus}
            disabled={!newManagement.contactType || disableTracking || trackingDisabled}
            onChange={(e) => {
              setData({ ...newManagement, trakingStatus: e.target.value, purchaseTerm: '' });
              setLabels({ ...labels, trakingStatus: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text });
            }}
            required={!(!newManagement.contactType || disableTracking || trackingDisabled)}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(tracking.entry, (e) => (
              <option key={e._id} value={e._id}>
                {e.name}
              </option>
            ))}
          </Input>
        </div>
      </div>
      <div className="crm-modal-form-group" hidden={!whenBuy}>
        <div className="crm-modal-input-group">
          <Label>Plazo Compra</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={newManagement.purchaseTerm}
            disabled={managementCreated.loading}
            required={whenBuy}
            onChange={(e) => setData({ ...newManagement, purchaseTerm: e.target.value })}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(purchaseTerm, (e) => (
              <option key={e.id} value={e.value}>
                {e.label}
              </option>
            ))}
          </Input>
        </div>
      </div>
      {newManagement.purchaseTerm === 'before 30' && <CRMComponent valuesHandler={valuesHandler} />}
      {(reminder || newManagement.purchaseTerm === 'after 30') &&
        <div className="crm-modal-form-group">
          <div className="crm-modal-input-group">
            <Label>Fecha Recordatorio</Label>
            <Input
              className='crm-modal-input-text'
              type='date'
              value={date.dateTask}
              onChange={(e) => setDate({ ...date, dateTask: e.target.value })}
              required={reminder}
              disabled={managementCreated.loading}
              min={moment(new Date()).format('YYYY-MM-DD')}
            />
          </div>
          <div className="crm-modal-input-group">
            <Label>Hora</Label>
            <Input
              className='crm-modal-input-text'
              type='time'
              value={date.time}
              onChange={(e) => setDate({ ...date, time: e.target.value })}
              required={reminder}
              disabled={managementCreated.loading}
            />
          </div>
        </div>
      }
      <div className="crm-modal-form-group-textarea">
        <div className="crm-modal-input-group">
          <Label>Descripción</Label>
          <Input
            className='crm-modal-input-textarea'
            type='textarea'
            value={newManagement.comment}
            onChange={(e) => setData({ ...newManagement, comment: e.target.value })}
            disabled={managementCreated.loading}
            maxLength='300'
            required
          />
        </div>
      </div>
    </div>
  )
};

export default NewGestionForm;